import theme from "../styles/Theme";

import { StyleProject, StyleProjectTitle, StyleContentsArea, StyleContentsLeft, StyleContentsRight, StyleContentsTitle, StyleContents, StyleContent, StyleProjectImage, StyleImages, StyleImage, StyleLookBack } from "../styles/StyleProjects"

import { StyleBadgeGreen } from '../styles/StyleCommon'

import Promotion1 from "../images/project/promotion1.jpg"
import Promotion2 from "../images/project/promotion2.jpg"
import Promotion3 from "../images/project/promotion3.png"
import Promotion4 from "../images/project/promotion4.png"

const BungaeCare = () => {
    return (
        <div>
            <StyleProject>
                <StyleContentsArea theme={theme}>
                    <StyleContentsLeft>
                        <blockquote>
                            <StyleProjectTitle>2023.12 - 2024.07</StyleProjectTitle>
                            <StyleProjectTitle>케어위크 & 무해한FLEX & 모안페</StyleProjectTitle>
                            <StyleBadgeGreen>spring boot 3.4.x</StyleBadgeGreen>
                            <StyleBadgeGreen>kotlin 2.2.x</StyleBadgeGreen>
                            <StyleBadgeGreen>mysql 8.x</StyleBadgeGreen>
                            <StyleBadgeGreen>jpa</StyleBadgeGreen>
                            <StyleBadgeGreen>redis</StyleBadgeGreen>
                            <StyleBadgeGreen>kinesis</StyleBadgeGreen>
                        </blockquote>
                    </StyleContentsLeft>
                    <StyleContentsRight>
                        <StyleContentsTitle>기획부터 운영까지 주도한 프로모션</StyleContentsTitle>
                        <StyleContents>
                            <StyleContent>2024년 케어위크(2월, 10월), 무해한 FLEX(4월), 모안페(8월, 9월) 총 5회의 프로모션 개발 및 운영</StyleContent>
                            <StyleContent>기획부터 개발까지 모두 참여하여 마케팅팀과 긴밀히 협업해, 짧은 기간 내 성공적으로 개발 및 배포</StyleContent>
                            <StyleContent>각 프로모션을 독립적인 도메인으로 분리하여 프로모션별 독립 배포와 확장이 가능한 구조 설계</StyleContent>
                            <StyleContent>응모권, 미션, 빙고, 랜덤 포인트 등 다양한 스킴을 개발하여 사용자 참여와 구매 전환을 높이며, 운영 오류 없이 서비스</StyleContent>
                        </StyleContents>
                        <StyleContentsTitle>성과로 말하는 프로모션</StyleContentsTitle>
                        <StyleContents>
                            <StyleContent>케어위크를 통해 번개케어 GMV를 98.5% 성장, 번개케어 상품의 PDP/PV 70% 증가</StyleContent>
                            <StyleContent>무해한 FLEX 프로모션 기간 내 안전 거래 건수 323% 증가, 번개포인트 160만 원으로 안전 거래 GMV 305% 상승</StyleContent>
                            <StyleContent>모안페 프모로션은 100% 안전결제 전환 캠페인에 맞춰 개발 및 안정적인 운영을 통해 전사 시스템 변화에 기여</StyleContent>
                            <StyleContent>확률 기반 캐시와 실시간 재고 추적으로 당첨 관리, 다수의 외부 서비스에 서킷브레이커를 적용하여 장애 전파 차단</StyleContent>
                        </StyleContents>
                        <StyleImages>
                            <StyleImage theme={theme} src={Promotion1} title="프로모션1" alt="" />
                            <StyleImage theme={theme} src={Promotion2} title="프로모션2" alt="" />
                            <StyleImage theme={theme} src={Promotion3} title="프로모션3" alt="" />
                            <StyleImage theme={theme} src={Promotion4} title="프로모션4" alt="" />
                        </StyleImages>
                    </StyleContentsRight>
                </StyleContentsArea>
            </StyleProject>
        </div>
    )
}

export default BungaeCare
